import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';

const PaymentChart = ({ data, title }) => {
  return (
    <div className="bg-white p-4 rounded shadow-md my-4">
      <h3 className="text-lg font-semibold mb-2">{title}</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid stroke="#ccc" />
          <XAxis dataKey="label" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="amount" stroke="#4f46e5" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PaymentChart;
